import { Fab, Theme, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { SxProps } from '@mui/system';

interface IAddTeamButtonProps {
  sx?: SxProps<Theme>;
  onAddTeam?(): void;
}

export const AddTeamButton = ({ onAddTeam, sx }: IAddTeamButtonProps) => (
  <Tooltip title="Add Team">
    <Fab sx={{ width: 25, height: 25, minHeight: 25, ...sx }} color="primary" aria-label="add" onClick={onAddTeam}>
      <AddIcon />
    </Fab>
  </Tooltip>
);
